import { FireAndFlowerCardData } from './fire-and-flower-card-data';

export class FireAndFlowerMemberPriceCardData extends FireAndFlowerCardData {
  static copyFrom(cardData: FireAndFlowerCardData): FireAndFlowerMemberPriceCardData {
    const copy = new FireAndFlowerMemberPriceCardData();
    copy?.copyFrom(cardData);
    return copy;
  }

  public readonly showRegularPriceAtBottom: boolean = true;
}
